




























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { PagerRow } from '@/views/List/listrow';

@Component({
  components: {},
})
export default class ListPager extends Vue {
  @Prop() value!: number;
  @Prop() pager!: PagerRow;

  @Emit('input')
  nextPage() {
    if (this.value == this.pager.totalPages)
      return this.value;

    return this.value + 1;
  }

  @Emit('input')
  previousPage() {
    if (this.value == 1)
      return this.value;

    return this.value - 1;
  }

  @Emit('input')
  firstPage() {
    if (this.value == 1)
      return this.value;
    return 1;
  }

  @Emit('input')
  lastPage() {
    if (this.value == this.pager.totalPages)
      return this.value;

    return this.pager.totalPages;
  }
}
